import React from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// Clear SEO fallback content before React renders
// This prevents hydration mismatch since we're not doing true SSR
const seoFallback = container.querySelector('.seo-fallback');
if (seoFallback) {
  container.innerHTML = '';
}

// Fresh render
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
